module.exports = __webpack_public_path__ + "img/timeline.a92d4403.svg";